module.exports = __webpack_public_path__ + "static/media/nicole_pinto.16cb8ffb.jpg";